import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'app-dashboard-widget-body',
    templateUrl: './dashboard-widget-body.component.html',
    styleUrls: ['./dashboard-widget-body.component.scss'],
    host: { class: 'block min-h-0 flex-1' },
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DashboardWidgetBodyComponent {
    @Input() compact = false;
    @Input() variant: 'default' | 'built-in' | 'report' | 'warning' | string = 'default';

    get isBuiltInBody(): boolean {
        return !this.compact && this.variant === 'built-in';
    }

    get isDefaultBody(): boolean {
        return !this.compact && this.variant !== 'built-in';
    }
}
